import React from 'react';
import '../styles/ProductionCard.css';
import { useNavigate } from 'react-router-dom';
import { Card } from 'react-bootstrap';
import { getDiscountedPrice } from '../utils/pricing';
type ProductCardProps = {
  id: string;
  title: string;
  price: number;
  sale?: number;
  imageUrl: string;
  currency: string;
};

const ProductCard: React.FC<ProductCardProps> = ({
  id,
  title,
  price,
  sale,
  imageUrl,
  currency,
}) => {
  const navigate = useNavigate();
  const { finalPrice, hasDiscount } = getDiscountedPrice(price, sale);

  const navigateToProductPage = () => {
    navigate(`/product/${id}`);
  };
  return (
    <Card className="product-card">
      <a href={`/product/${id}`}>
        <Card.Img variant="top" src={imageUrl} />
      </a>

      <Card.Body>
        <div className="product-card-body">
          <div className="title-price flex-column">
            <Card.Title>{title}</Card.Title>
            <div className="brand-price">
              <span className="current-price">
                {currency} {finalPrice.toFixed(2)}
              </span>
              {hasDiscount && (
                <span className="original-price">
                  {currency} {price.toFixed(2)}
                </span>
              )}
            </div>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default ProductCard;
